import { marginMixin } from './marginMixin';
import { mediaQueryMixin } from './mediaQueryMixin';
import { paddingMixin } from './paddingMixin';
var spacingMediaQueryMixin = mediaQueryMixin(function (mediaProps) {
  return function (props) {
    var forwardedProps = Object.assign({}, props, mediaProps);
    return [marginMixin(forwardedProps), paddingMixin(forwardedProps)];
  };
});

/** @mixin spacingMixin */
/**
 * Adds margin and padding props.
 *
 * <ul>
 *     <li><code>margin</code></li>
 *     <li><code>marginX</code></li>
 *     <li><code>marginY</code></li>
 *     <li><code>marginTop</code></li>
 *     <li><code>marginBottom</code></li>
 *     <li><code>marginLeft</code></li>
 *     <li><code>marginRight</code></li>
 *     <li><code>padding</code></li>
 *     <li><code>paddingX</code></li>
 *     <li><code>paddingY</code></li>
 *     <li><code>paddingTop</code></li>
 *     <li><code>paddingBottom</code></li>
 *     <li><code>paddingLeft</code></li>
 *     <li><code>paddingRight</code></li>
 * </ul>
 *
 * @example
 * import { spacingMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${spacingMixin}
 * `;
 *
 * <Component margin="lg" paddingX="sm" paddingTop="xs" />
 *
 * @method
 * @param {object} props
 * @param {object} props.theme - The styled-components theme object.
 * @return {CSSObject}
 */
export var spacingMixin = function spacingMixin(props) {
  return [marginMixin(props), paddingMixin(props), spacingMediaQueryMixin];
};